import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import CardContainer from "@src/components/cards/CardContainer";
import HorizontalLayout from "@src/components/cards/HorizontalLayout";
import { ImageWrapper } from "@src/components/atoms";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

export const cardWithIcon = (
  key,
  title,
  amount,
  imgURL,
  isFullWidth,
  fail,
  noRadius,
  bgColor,
) => {
  return (
    <div key={key} className={`${isFullWidth ? "w-full" : "w-auto"}`}>
      <CardContainer
        bgColor={!!fail ? "silver-200" : `${bgColor}-100`}
        shadow={false}
      >
        <HorizontalLayout ratio={[1, 2]} className={"h-full"} gap={0}>
          <div className="h-full w-full flex items-center justify-center">
            <ImageWrapper src={imgURL} size={"md"} />
          </div>

          <div className="ml-4 items-center">
            <div className="text-md">{title}</div>
            <div className="font-bold text-lg">{amount}</div>
          </div>
        </HorizontalLayout>
      </CardContainer>
    </div>
  );
};

const BehaviourSaveOrFailCard = (props) => {
  const {
    behaviour,
    justify,
    hasInsights,
    titleCO2,
    titleFuel,
    industry,
    msgCO2,
    msgFuel,
    iconCO2,
    iconFuel,
  } = props;
  const bvr = behaviour;
  const cards = [];

  if (!bvr.isSuccess) {
    const title1 = titleCO2 ? titleCO2 : "Fuel needed";
    const icon1 = !!iconCO2
      ? iconCO2
      : industry === "aviation"
        ? "https://signol-email-images.s3.eu-west-2.amazonaws.com/grey_plane_icon.svg"
        : "https://signol-email-images.s3.eu-west-2.amazonaws.com/best_event_ship.svg";
    cards.push(
      cardWithIcon(
        `${bvr.id}:impact`,
        title1,
        msgCO2,
        icon1,
        !justify,
        true,
        true,
        "neutral",
      ),
    );

    const title2 = titleFuel ? titleFuel : "Carrying all fuel burnt";
    const icon2 = !!iconFuel
      ? iconFuel
      : "https://signol-email-images.s3.eu-west-2.amazonaws.com/grey_factory_icon.svg";
    cards.push(
      cardWithIcon(
        `${bvr.id}:saving`,
        title2,
        msgFuel,
        icon2,
        !justify,
        true,
        true,
        "neutral",
      ),
    );
  }

  if (!!bvr.isSuccess && bvr.fuelSavedKg && bvr.fuelSavedKg > 0) {
    cards.push(
      cardWithIcon(
        `${bvr.id}:impact`,
        titleCO2,
        msgCO2,
        iconCO2,
        !justify,
        false,
        true,
        "primary",
      ),
    );
    cards.push(
      cardWithIcon(
        `${bvr.id}:saving`,
        titleFuel,
        msgFuel,
        iconFuel,
        !justify,
        false,
        true,
        "primary",
      ),
    );
  }

  return (
    <div
      className={`w-full h-full flex flex-col ${
        !hasInsights ? "md:flex-row" : ""
      } min-h-full  overflow-y-auto custom-scroll text-sm md:text-base gap-4
        `}
    >
      {cards}
    </div>
  );
};

export const behaviourSaveOrFailCardControls = {
  behaviour: {
    propType: PropTypes.object,
    description: "Event data object",
    controlType: "object",
  },
  industry: COMMON_CONTROLS.industry,
  titleCO2: {
    propType: PropTypes.string,
    description: "Card message",
    controlType: "text",
  },
  titleFuel: {
    propType: PropTypes.string,
    description: "Card message",
    controlType: "text",
  },
  msgCO2: {
    propType: PropTypes.string,
    description: "Card message",
    controlType: "text",
  },
  msgFuel: {
    propType: PropTypes.string,
    description: "Card message",
    controlType: "text",
  },
  iconCO2: {
    propType: PropTypes.string,
    description: "Card message",
    controlType: "text",
  },
  iconFuel: {
    propType: PropTypes.string,
    description: "Card message",
    controlType: "text",
  },
};

BehaviourSaveOrFailCard.propTypes = AppUtils.getPropTypeFromControls(
  behaviourSaveOrFailCardControls,
);

export default BehaviourSaveOrFailCard;
